module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point2_2-dcb36f990f9c51c21cb729c2752740b1.jpg";